const visibility = {
  update: async () => {
    // Placeholder for visibility select refactor
  },
}

export default visibility
